import { type PreviewStaticModule } from '@/lib/builder/types'

import FormFooterEditor from './editor/FormFooterEditor.vue'
import FormFooterPreview from './preview/FormFooterPreview.vue'

export const FormFooterStaticModule: PreviewStaticModule = {
  editor: FormFooterEditor,
  preview: FormFooterPreview,
}
